module.exports = __webpack_public_path__ + "img/3.2ddf2a75.jpg";